import Button from '@components/Button';
import {useAuthUser} from '@crema/utility/AppHooks';
import IntlMessages from '@crema/utility/IntlMessages';
import {Typography} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {AppState} from 'redux/store';
import {CLoseHeader, toggleNavCollapsed} from '../../../../redux/actions';
import AppLogoWhite from '../../../../shared/components/AppLogoWhite';
import HeaderMessages from '../../HeaderMessages';
import LanguageSwitcher from '../../LanguageSwitcher';
import Notifications from '../../Notifications';
import HorUserInfo from '../HorUserInfo';
import useStyles from './AppHeader.style';
import NotificationBar from './NotificationBar';

// const RESTRICTED_CLIENTS = [
//   'dani.dh786@gmail.com',
//   'airdrie@countrywidenorth.co.uk',
//   // 'ayr@countrywidenorth.co.uk',
//   'baillieston@countrywidenorth.co.uk',
//   'burnside@countrywidenorth.co.uk',
//   'cityliving@countrywidenorth.co.uk',
//   'clarkston@countrywidenorth.co.uk',
//   'stuart.clelland@countrywide.co.uk',
//   // 'eastkilbride@countrywidenorth.co.uk',
//   'hamilton@countrywidenorth.co.uk',
//   // 'irvine@countrywidenorth.co.uk',
//   // 'Kilmarnock@countrywidenorth.co.uk',
//   'kirkintilloch@countrywidenorth.co.uk',
//   'paisley@countrywidenorth.co.uk',
//   'shawlands@countrywidenorth.co.uk',
//   'westend@countrywidenorth.co.uk',
//   'aidan.reid@slaterhogg.co.uk',
//   'Stuart.Tulloch@slaterhogg.co.uk',
//   'Manager.bridgeofweir@slaterhogg.co.uk',
//   'Manager.burnside@slaterhogg.co.uk',
//   'candleriggs@slaterhogg.co.uk',
//   'Manager.clarkston@slaterhogg.co.uk',
//   'Manager.cumbernauld@slaterhogg.co.uk',
//   'dennistoun@slaterhogg.co.uk',
//   'Manager.eastkilbride@slaterhogg.co.uk',
//   'Manager.falkirk@slaterhogg.co.uk',
//   'glenrothes@slaterhogg.co.uk',
//   'Manager.greenock@slaterhogg.co.uk',
//   'Manager.hamilton@slaterhogg.co.uk',
//   'Manager.helensburgh@slaterhogg.co.uk',
//   'valuer1.bearsden@slaterhogg.co.uk',
//   'steven.mcclure@slaterhogg.co.uk',
//   'Manager.kirkcaldy@slaterhogg.co.uk',
//   'largs@slaterhogg.co.uk',
//   'Manager.livingston@slaterhogg.co.uk',
//   'Vicky.simpson@slaterhogg.co.uk',
//   'valuer.paisley@slaterhogg.co.uk',
//   'manager.shawlands@slaterhogg.co.uk',
//   'Manager.stirling@slaterhogg.co.uk',
//   'Manager.troon@slaterhogg.co.uk',
//   'westend@slaterhogg.co.uk',
//   'paul.cargill@shhlettings.co.uk',

//   // New York Clients
//   'louiseanne.litao@compass.com',
//   'julie.kopel@compass.com',
//   'stacey.kanbar@compass.com',
//   'Nicholas.delotell@Compass.com',
//   'Adminassistant@meierrealestate.com',
//   'alicia.grosso@sothebys.realty',
//   'michael@meierrealestate.com',
//   'Jordana.kosow@Compass.com',
//   'Kelly.robinson@Compass.com',
//   'samantha.dellanoce@compass.com',
//   'Marygrace.mcgivney@Compass.com',
//   'amelnick@compass.com',
//   'ACO@corcoran.com',
//   'benjamin.gernandt@compass.com',
//   'biancac@compass.com',
//   'cristina.camello@compass.com',
//   'david.berger@compass.com',
//   'elena.kagiou@compass.com',
//   'harry.diorio@compass.com',
//   'Hillel.fried@Compass.com',
//   'ivy.balilaon@compass.com',
//   'terrence.harding@compass.com',
//   'jamesistribeca@gmail.com',
//   'jessica.quinn@compass.com',
//   'kellyn.goudie@compass.com',
//   'linette.semino@compass.com',
//   'mnissan@sagerealty.com',
//   'milena.baram@compass.com',
//   'neil.porter@compass.com',
//   'Rachel.pouyafar@Compass.com',

//   // Florida Clients
//   'CherylSchweigart@keyes.com',
//   'claudia.sanroman@yahoo.com',
//   'amit.bhuta@compass.com',
//   'geane.brito@compass.com',
//   'celia.ruiz@compass.com',
//   'ellen@ellendimarco.com',
//   'stephanie@aquantisrealty.com',
//   'pkoedatich@ipre.com',
//   'michael.zeoli@compass.com',
//   'luciana.barreto@compass.com',
//   'bea.citron@compass.com',
//   'ksingleton@ipre.com',
//   'Tamipettingell@Keyes.com',
//   'corinwiser@keyes.com',
//   'fernandoamaya@keyes.com',
//   'bgraeve@bellsouth.net',
//   'ginahardwood@keyes.com',
//   'coleton@flanneryteam.com',
//   'rstosh@icloud.com',
//   'bhartman@ipre.com',
//   'alammersdorf@ipre.com',
// ];

const RESTRICTED_CLIENTS = [];

interface AppHeaderProps {}

const AppHeader: React.FC<AppHeaderProps> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const {CloseHeader} = useSelector<AppState, AppState['common']>(
    ({common}) => common,
  );
  const user = useAuthUser();
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    useState<null | HTMLElement>(null);
  const [showMessage, setShowMessage] = useState(false);

  function handleMobileMenuClose() {
    setMobileMoreAnchorEl(null);
  }

  useEffect(() => {
    if (user) {
      dispatch(CLoseHeader(false));
    } else {
      dispatch(CLoseHeader(true));
    }
  }, [user]);

  function onNewOrder() {
    // if (RESTRICTED_CLIENTS.includes(user?.user?.username)) {
    //   setShowMessage(true);
    //   setTimeout(() => setShowMessage(false), 3000);
    //   return;
    // }

    setShowMessage(true);
    setTimeout(() => setShowMessage(false), 3000);
    return;

    // if (user) {
    //   history.push('/order/new');
    // } else {
    //   history.push('/signin');
    // }
  }

  const [showBlackNavlist, setshowBlackNavlist] = useState(false);

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{vertical: 'top', horizontal: 'right'}}
      open={Boolean(mobileMoreAnchorEl)}
      onClose={handleMobileMenuClose}>
      <MenuItem className={classes.menuItemRoot}>
        <HeaderMessages />
      </MenuItem>
      <MenuItem className={classes.menuItemRoot}>
        <Notifications />
      </MenuItem>
      <LanguageSwitcher />
    </Menu>
  );

  return (
    <>
      <AppBar className='position-sticky top-0'>
        <NotificationBar />
        {/* {<AppNavList show={showBlackNavlist} setshowBlackNavlist={setshowBlackNavlist} />} */}

        <Toolbar className={classes.headerMain}>
          <Box className={classes.headerContainer}>
            <Box className={classes.headerMainFlex}>
              <Box mx={2} />
              <Hidden lgUp>
                <IconButton
                  edge='start'
                  color='inherit'
                  aria-label='open drawer'
                  onClick={() => dispatch(toggleNavCollapsed())}>
                  <MenuIcon className={classes.menuIconRoot} />
                </IconButton>
              </Hidden>

              {/* <Link to={'#'}  onClick={() => dispatch(CLoseHeader(!CloseHeader))}> */}
              <a href={'https://vistabee.com/'}>
                <AppLogoWhite />
              </a>

              <Box className={classes.grow} />

              <Box className={classes.sectionWeb}>
                <Box className={classes.FlagContainer}>
                  <img
                    src='/assets/images/flags/us_image.png'
                    width='30px'
                    alt='us_image'
                  />
                  <Typography> 1 646 583 0200</Typography>
                </Box>
                <Box className={classes.FlagContainer}>
                  <img
                    src='/assets/images/flags/uk_image.jpg'
                    width='30px'
                    alt='uk_image'
                  />
                  <Typography> 0333 044 0030 </Typography>
                </Box>
                <Box
                  width={300}
                  display='flex'
                  alignItems='center'
                  justifyContent='flex-end'
                  position='relative'>
                  <Button
                    height={35}
                    variant='secondary'
                    onClick={user ? onNewOrder : () => history.push('/signin')}
                    disabled={user?.user_type.includes('bee')}
                    style={{
                      opacity: RESTRICTED_CLIENTS.includes(user?.user?.username)
                        ? 0.5
                        : 1,
                    }}>
                    <IntlMessages
                      id='common.newOrder'
                      defaultMessage={user ? 'Place Order' : 'Get Started'}
                    />
                  </Button>
                  {showMessage && (
                    <Typography
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: '#fff3cd',
                        color: '#856404',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        marginTop: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        zIndex: 1000,
                        whiteSpace: 'nowrap',
                      }}>
                      Please place order on new platform
                    </Typography>
                  )}
                  {!CloseHeader && <HorUserInfo onlyAvatar={true} />}
                </Box>
              </Box>

              <Box ml={1} className={classes.sectionMobile}>
                <Box className={classes.FlagContainer}>
                  <Button
                    variant='secondary'
                    onClick={user ? onNewOrder : () => history.push('/signin')}
                    className={classes.PlaceOrderButton}
                    disabled={user?.user_type.includes('bee')}>
                    <IntlMessages
                      id='common.newOrder'
                      defaultMessage={user ? 'Place Order' : 'Get Started'}
                    />
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
    </>
  );
};
export default AppHeader;
